import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-patrons',
  templateUrl: './patrons.component.html',
  styleUrls: ['./patrons.component.scss']
})
export class PatronsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
